import script from "./FancyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FancyButton.vue?vue&type=script&setup=true&lang=ts"

import "./FancyButton.vue?vue&type=style&index=0&id=794b8926&lang=postcss"

const __exports__ = script;

export default __exports__